
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitomahabaleshwercab() {



    const cardData =
    {
        keyword: 'Mumbai to Mahabaleshwar Cab',
        heading: 'S9 Travels:  Mumbai to Mahabaleshwar Cab',
        headingDescription: 'S9 Travels offers Mumbai to Mahabaleshwar Cab Service, ensuring a comfortable, reliable, and hassle-free journey. Whether you are planning a weekend getaway, family trip, or honeymoon, our Innova cabs provide a smooth and enjoyable ride to the scenic hill station. With spacious interiors, luxury features, and professional drivers, we guarantee a safe and stress-free travel experience. Enjoy on-time pickups, affordable pricing, and 24/7 service. Book your Mumbai to Mahabaleshwar cab with S9 Travels for a seamless and memorable trip!',


        top: 'Top Places to Visit in Mahabaleshwar  with S9 Travels',

"topPlaces": [
    {
      "title": "Venna Lake",
      "description": "A picturesque lake surrounded by lush greenery, Venna Lake is a popular spot for boating and enjoying the serene atmosphere."
    },
    {
      "title": "Arthur’s Seat",
      "description": "One of the most famous viewpoints in Mahabaleshwar, Arthur’s Seat offers breathtaking panoramic views of the valleys and Savitri River below."
    },
    {
      "title": "Elephant’s Head Point",
      "description": "This viewpoint resembles the shape of an elephant’s head and trunk, offering spectacular views of the Sahyadri hills and deep valleys."
    },
    {
      "title": "Pratapgad Fort",
      "description": "A historic fort built by Chhatrapati Shivaji Maharaj, Pratapgad Fort is known for its stunning architecture and historical significance."
    },
    {
      "title": "Mapro Garden",
      "description": "Famous for its delicious strawberry-based products, Mapro Garden is a must-visit for fresh fruit lovers, ice creams, and shopping for jams and syrups."
    },
    {
      "title": "Lingmala Waterfall",
      "description": "A stunning waterfall located in the midst of nature, Lingmala Waterfall is best visited during the monsoon season for a mesmerizing view."
    },
    {
      "title": "Wilson Point",
      "description": "The highest point in Mahabaleshwar, Wilson Point is perfect for catching breathtaking sunrises and panoramic views of the surrounding hills."
    },
    {
      "title": "Panchgani",
      "description": "A beautiful hill station near Mahabaleshwar, Panchgani is known for its scenic beauty, strawberry farms, and Table Land—a vast volcanic plateau."
    },
    {
      "title": "Babington Point",
      "description": "A lesser-known but serene viewpoint, Babington Point is an ideal place for nature lovers to enjoy peaceful surroundings and birdwatching."
    },
    {
      "title": "Mahabaleshwar Temple",
      "description": "An ancient temple dedicated to Lord Shiva, Mahabaleshwar Temple is a significant religious site known for its spiritual aura and historical importance."
    }
],

"services": [
    {
      "name": "Mumbai to Mahabaleshwar Cab Service",
      "description": "S9 Travels offers reliable and comfortable cab services from Mumbai to Mahabaleshwar. Whether you're traveling for leisure or a family trip, our cabs ensure a smooth and enjoyable journey."
    },
    {
      "name": "Book Mumbai to Mahabaleshwar Taxi",
      "description": "Booking a taxi from Mumbai to Mahabaleshwar with S9 Travels is simple and hassle-free. Choose from one-way or round-trip options and enjoy a comfortable ride to the hill station."
    },
    {
      "name": "Affordable Mumbai to Mahabaleshwar Cab",
      "description": "S9 Travels offers affordable taxi services from Mumbai to Mahabaleshwar, providing a budget-friendly way to travel in comfort and style to one of the most popular hill stations in Maharashtra."
    },
    {
      "name": "Luxury Cab from Mumbai to Mahabaleshwar",
      "description": "Travel in luxury with S9 Travels' premium cab service from Mumbai to Mahabaleshwar. Our luxury vehicles are well-maintained and equipped with top-tier amenities for a comfortable and relaxing journey."
    },
    {
      "name": "Mahabaleshwar Trip by Cab from Mumbai",
      "description": "Make your Mahabaleshwar trip special with S9 Travels' comfortable and reliable cab services. Whether it's a family getaway or a romantic holiday, our cabs ensure a pleasant and stress-free ride."
    },
    {
      "name": "Private Taxi for Mahabaleshwar from Mumbai",
      "description": "Choose S9 Travels for a private taxi from Mumbai to Mahabaleshwar. Enjoy personalized service, privacy, and a direct route to the hill station with our professional drivers."
    },
    {
      "name": "Mahabaleshwar Sightseeing by Taxi from Mumbai",
      "description": "Explore Mahabaleshwar’s scenic beauty with S9 Travels’ sightseeing taxi service. Our expert drivers will guide you to all the popular attractions, ensuring a memorable trip."
    },
    {
      "name": "Group Travel to Mahabaleshwar",
      "description": "S9 Travels provides spacious cabs for group travel from Mumbai to Mahabaleshwar. Whether it’s a family reunion or a friends’ getaway, our cabs offer the perfect solution for group transportation."
    },
    {
      "name": "Comfortable Mumbai to Mahabaleshwar Taxi Service",
      "description": "S9 Travels offers a comfortable and smooth taxi service from Mumbai to Mahabaleshwar. Our experienced drivers and well-maintained vehicles ensure a safe and relaxing journey."
    },
    {
      "name": "Mahabaleshwar Holiday by Private Taxi",
      "description": "Enjoy a holiday in Mahabaleshwar with a private taxi from Mumbai. S9 Travels provides personalized taxi services to ensure a luxurious and comfortable trip to the hill station."
    }
],

"tableData": [
  ["Mumbai to Mahabaleshwar Cab Service", "Book Mumbai to Mahabaleshwar Taxi"],
  ["Affordable Mumbai to Mahabaleshwar Cab", "Luxury Cab from Mumbai to Mahabaleshwar"],
  ["Mahabaleshwar Trip by Cab from Mumbai", "Private Taxi for Mahabaleshwar from Mumbai"],
  ["Mahabaleshwar Sightseeing by Taxi from Mumbai", "Group Travel to Mahabaleshwar"],
  ["Comfortable Mumbai to Mahabaleshwar Taxi Service", "Mahabaleshwar Holiday by Private Taxi"],

],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Scenic Long-Distance Journey",
    "WhyChoosedescription": "S9 Travels offers a comfortable Mumbai to Mahabaleshwar cab service, perfect for long-distance travel. Our well-maintained vehicles, including the Toyota Innova, provide ample space, air conditioning, and smooth interiors, ensuring that you enjoy a relaxing journey through the beautiful landscapes to Mahabaleshwar."
  },
  {
    "WhyChooseheading": "Timely and Reliable Service",
    "WhyChoosedescription": "Whether you're traveling for leisure, family trips, or a special event, our Mumbai to Mahabaleshwar cab service ensures timely pick-ups and reliable service. We prioritize punctuality, so you can relax and enjoy the ride without any worry of delays."
  },
  {
    "WhyChooseheading": "Experienced Drivers for a Safe Trip",
    "WhyChoosedescription": "Our drivers are experienced and familiar with the route from Mumbai to Mahabaleshwar. They ensure a smooth, safe, and efficient journey, navigating the hills and winding roads with expertise, so you can enjoy the trip with peace of mind."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for the Mumbai to Mahabaleshwar cab service. We believe in transparent pricing with no hidden charges, providing you with a clear cost breakdown during the booking process, so you can plan your travel budget efficiently."
  },
  {
    "WhyChooseheading": "Safety and Comfort on the Road",
    "WhyChoosedescription": "Your safety is our priority. Our cabs are equipped with modern safety features, including GPS tracking, airbags, and seat belts, to ensure that your journey from Mumbai to Mahabaleshwar is secure and comfortable, no matter the road conditions."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your Mumbai to Mahabaleshwar trip. Whether you need an early morning departure or a late-night return, our customer service team is available to assist you at any time."
  },
  {
    "WhyChooseheading": "Customizable Travel Plans for Your Needs",
    "WhyChoosedescription": "We understand that every journey is unique. Whether you want to make stops along the way, need special arrangements, or want a specific itinerary, we offer customizable travel plans for your Mumbai to Mahabaleshwar journey, ensuring a tailored and enjoyable experience."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking a Mumbai to Mahabaleshwar cab with S9 Travels is easy and convenient. You can book online via our website or mobile app, or reach out to our customer service team for personalized assistance. We ensure that the booking process is smooth and stress-free."
  }
]















    }


    const faqData = [
        [
          {
            question: 'How can I book a cab from Mumbai to Mahabaleshwar with S9 Travels?',
            answer: 'Booking a cab from Mumbai to Mahabaleshwar is simple! You can book your ride through our website or app, or contact our customer service team for personalized assistance in planning your trip.',
          },
          {
            question: 'What types of vehicles are available for Mumbai to Mahabaleshwar travel?',
            answer: 'We offer a variety of vehicles for your Mumbai to Mahabaleshwar journey, including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose the one that best suits your needs for a comfortable and scenic ride.',
          },
          {
            question: 'How long does the journey from Mumbai to Mahabaleshwar take?',
            answer: 'The journey from Mumbai to Mahabaleshwar typically takes around 5 to 6 hours, depending on traffic and road conditions. Our experienced drivers will ensure a smooth and safe ride to this beautiful hill station.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel like Mumbai to Mahabaleshwar?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and are familiar with the best routes to Mahabaleshwar. They ensure a safe, comfortable, and enjoyable journey through the scenic routes.',
          },
          {
            question: 'Can I book a round trip for Mumbai to Mahabaleshwar?',
            answer: 'Yes, we offer round-trip bookings for your Mumbai to Mahabaleshwar journey. You can plan your return trip based on your schedule, and we will ensure a smooth and timely journey back to Mumbai.',
          },
          {
            question: 'Is there a fixed fare for Mumbai to Mahabaleshwar cab service?',
            answer: 'The fare for Mumbai to Mahabaleshwar travel depends on the type of vehicle, trip duration, and specific requirements. Contact us for a customized quote for your trip to ensure you get the best rate.',
          },
          {
            question: 'Do you provide pick-up services from Mumbai airport or hotels for Mahabaleshwar trips?',
            answer: 'Yes, we provide convenient pick-up services from Mumbai airport or your hotel. Our driver will ensure a smooth transfer, making your journey to Mahabaleshwar comfortable and stress-free from the start.',
          },
          {
            question: 'Can I request additional stops on the way to Mahabaleshwar?',
            answer: 'Yes, we can arrange additional stops for sightseeing or breaks during your journey to Mahabaleshwar. Just let us know when booking, and we will customize the trip to include your preferred stops.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Mumbai to Mahabaleshwar trip?',
            answer: 'Any extra charges for waiting time or detours will be communicated upfront at the time of booking. We ensure full transparency in pricing so that you are aware of any additional costs before the trip.',
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai to Mahabaleshwar cab service?',
            answer: 'S9 Travels offers reliable, comfortable, and safe cab services for your Mumbai to Mahabaleshwar journey. With well-maintained vehicles, experienced drivers, and exceptional customer service, we ensure a pleasant and enjoyable trip to Mahabaleshwar.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Sanjay Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip from Mumbai to Mahabaleshwar with S9 Travels was amazing. The driver was professional, and the car was clean and comfortable for the long journey. The scenic route made the trip even more enjoyable. Highly recommend S9 Travels for trips to Mahabaleshwar!”',
        },
        {
          name: 'Mrs. Neha Rathi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I traveled to Mahabaleshwar from Mumbai with S9 Travels, and it was a great experience. The driver knew the route well and made sure the ride was smooth and comfortable. The vehicle was in excellent condition, and I will definitely choose S9 Travels again for future trips!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
     
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai to Mahabaleshwar Cab",
        "description": "Book affordable and reliable Mumbai to Mahabaleshwar cab services for one-way trips, round trips, luxury cabs, and group travel. S9 Travels offers private taxi rides for a comfortable journey from Mumbai to Mahabaleshwar, including sightseeing tours and holiday trips.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     


    return (
        <div>
         <Helmet>
        <title>Mumbai to Mahabaleshwar Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Mumbai to Mahabaleshwar taxi services, including one-way, round-trip, and luxury cabs. Comfortable and affordable transport for sightseeing tours, group travel, and holidays from Mumbai to Mahabaleshwar with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
      

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/54.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitomahabaleshwercab;